export default __webpack_public_path__ + "static/media/Edit.95e08fdd.svg";